import React,{Component} from 'react';
// import PropTypes from 'prop-types';

// Components
import {
  Row,
  Col,
  FormText,
  FormGroup,
  Popover,
  PopoverBody 
} from 'reactstrap';

import {
  CardNumberElement,
  CardExpiryElement,
  CardCVCElement,
  PostalCodeElement
} from 'react-stripe-elements';

import InformationSVG from '../../assets/information.svg';
import CreditCardCVCSVG from '../../assets/creditcard-cvc.svg';

// Styles
const stripeElementStyle = {
  base: {
    fontSize: '15px',
    fontFamily:'sans-serif',
    '::placeholder': {color: '#868e96'}
  }
}

class CreditCardForm extends Component {
  constructor(){
    super();

    this.state = {
      isShowingPopover:false,
      isSaving:false
    };
  }

  render(){
    const {validationMessages} = this.props

    return (
      <div className="CreditCardForm">
        <div>
          <Row>
            <Col xs={12}>
              <FormGroup>
                <div className="form-control">
                  <CardNumberElement
                    placeholder="Card number"
                    style={stripeElementStyle}
                  />
                </div>
                {validationMessages['number'] && (
                  <FormText className='DangerFeedback'>
                    {validationMessages['number']}
                  </FormText>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={6} sm={4}>
              <FormGroup>
                <div className="form-control">
                  <CardExpiryElement style={stripeElementStyle} />
                </div>
                {validationMessages['expiry'] && (
                  <FormText className='DangerFeedback'>
                    {validationMessages['expiry']}
                  </FormText>
                )}
              </FormGroup>
            </Col>

            <Col xs={5} sm={{size: 3, offset: 4}}>
              <FormGroup>
                <div className="form-control">
                  <CardCVCElement style={stripeElementStyle} />
                </div>  
                {validationMessages['cvc'] && (
                  <FormText className='DangerFeedback'>
                    {validationMessages['cvc']}
                  </FormText>
                )}              
              </FormGroup>
            </Col>
            <Col xs='1' sm='1'>
              <img
                style={{position:'relative',left:-10,top:7}}
                alt='CVC information'
                src={InformationSVG}
                id='CVCInfoIcon'
                onMouseEnter={() => this.setState({isShowingPopover:true})}
                onMouseLeave={() => this.setState({isShowingPopover:false})}
              />
              <Popover
                className='TooltipPopover'
                isOpen={this.state.isShowingPopover}
                target='CVCInfoIcon'
                placement='right'
              >
                <PopoverBody>
                  This is a 3 or 4 digit security code located on the back or front (Amex) of your card.
                  <br />
                  <br />
                  <img src={CreditCardCVCSVG} alt='Check on the back for your CVC' />
                </PopoverBody>
              </Popover>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12}>
              <FormGroup>
                <div className="form-control">
                  <PostalCodeElement
                    style={stripeElementStyle}
                    placeholder="Postal Code"
                  />
                </div>
                {validationMessages['zip'] && (
                  <FormText className='DangerFeedback'>
                    {validationMessages['zip']}
                  </FormText>
                )}   
              </FormGroup>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

CreditCardForm.defaultProps = {
  onSubmit:() => {},
  validationMessages:{}
};

export default CreditCardForm;



// WEBPACK FOOTER //
// ./src/shared/components/CreditCardForm/CreditCardForm.js